module.exports = __webpack_public_path__ + "images/info-99105eda.svg";